module.exports = __webpack_public_path__ + "static/mr-concert-performance-02-2789dc1ee5d76488edf666fd66d10888.jpg";